import React from 'react'
import {
  Card,
  CardHeader,
  Table
} from 'reactstrap'
import PriceUtil from 'utils/price-util'
import PropTypes from 'prop-types'

const propTypes = {
  revenue: PropTypes.shape({
    total_revenue            : PropTypes.number,
    total_fee_payment_amount : PropTypes.number,
    grand_total              : PropTypes.number
  })
}

const defaultProps = {
  revenue: {
    total_revenue            : 0,
    total_fee_payment_amount : 0,
    grand_total              : 0
  }
}

const RevenueDetailSummaryCard = ({ revenue }) => (
  <Card>
    <CardHeader className='font-weight-bold'  style={{ background: '#ed569a', color: 'white' }}>
      { 'Summary' }
    </CardHeader>
    <div style={{ overflowX: 'auto' }}>
      <Table className="mb-0">
        <tbody>
          <tr>
            <td>
                Revenue
            </td>
            <td>
              { PriceUtil.format(revenue.total_revenue) }
            </td>
          </tr>
          <tr>
            <td>
                Processing Fee
            </td>
            <td>
                -({ PriceUtil.format(revenue.total_fee_payment_amount) })
            </td>
          </tr>

          <tr className='font-weight-bold border'>
            <td>
                Total
            </td>
            <td>
              { PriceUtil.format(revenue.grand_total) }
            </td>
          </tr>

        </tbody>
      </Table>
    </div>
  </Card>
)

RevenueDetailSummaryCard.propTypes    = propTypes
RevenueDetailSummaryCard.defaultProps = defaultProps

export default RevenueDetailSummaryCard
